export default __webpack_public_path__ + "static/media/avatar_60.00e82d51.png";